import type { Middleware } from '@nuxt/types';

const logPageViewsMiddleware: Middleware = ({ route: { path }, from, app }) => {
  if (!from) return;

  const { path: oldPath } = from;
  if (path !== oldPath) {
    app.$analytics.logPageView();
  }
};

export default logPageViewsMiddleware;
